export function Browser() {
    let browser: 'chrome' | 'edge' | 'firefox' | 'safari' | 'unknown';
    if (navigator.userAgent.includes('Chrome')) {
        browser = 'chrome';
    } else if (navigator.userAgent.includes('Edg')) {
        browser = 'edge';
    } else if (navigator.userAgent.includes('Firefox')) {
        browser = 'firefox';
    } else if (navigator.userAgent.includes('Safari')) {
        browser = 'safari';
    } else {
        browser = 'unknown';
    }
    return browser;
}